import { deepGet } from 'ts-deep-utils'
import { useI18n } from 'vue-i18n'

const isTranslationObject = (x: unknown): x is Record<string, string> => {
  return typeof x === 'object' && x != null
}

export function useDecisionI18n() {
  const { locale } = useI18n()
  return {
    tDecision: (object: Record<string, unknown> | undefined, key: string): string | undefined => {
      if (object == null) return key

      const base = deepGet(object, key)
      if (!isTranslationObject(base)) return key

      return base[locale.value] ?? base.en ?? base.sv ?? key
    },
  }
}
